import Notify from "utils/notify";
import Cookies from "js-cookie";

import { removeAuth } from "api";
import { removeAllCookie } from "utils/StorageVariables";
import { ActionTypes } from "./types";
import { ToggleInfoSidebarAction, ToggleSidebarAction, setSelectedClient, resetAllState } from "Redux/Global/action";
import { setUserId, track, reset } from 'utils/amplitude';
import { isDigitalOcean } from "config";

export const Logout = (Navigate) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });

    const { data: response } = await removeAuth();

    dispatch({
      type: ActionTypes.SUCCESS
    });

    if (response) {
      if (process.env.NODE_ENV === 'development' || isDigitalOcean)
        Cookies.remove('token-local');

      // Clear cookies
      removeAllCookie();

      // Reset all Redux state
      dispatch(resetAllState());

      // Amplitude
      setUserId(undefined);
      reset();
      track('Logged Out');

      // Reset specific UI state that should be reset on logout
      dispatch(ToggleSidebarAction('left'));
      dispatch(ToggleInfoSidebarAction(false));
      dispatch(setSelectedClient(false));

      Navigate("/", { replace: true });
    }
  } catch (error) {
    Notify.error(error, true);

    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });

    if (process.env.NODE_ENV === 'development' || isDigitalOcean)
      Cookies.remove('token-local');
      
    removeAllCookie();
    dispatch(resetAllState());
    Navigate("/", { replace: true });
  }
};
